import Map from 'eemovel-map-library/src/data/google-maps/map';
import ClusterIcon from '../../../../assets/img/Ellipse_39.svg';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import Icon from '../../../../assets/img/CIRCLE-red-border.svg';
import { updateMarkers, updateClusters } from '../../redux/dashboardActions';
import {
  generateInfoWindow,
  generateBuildingDetails,
} from './realtyTransactions.controller';
import infoWindowRealtyTransactions from './realtyTransactions.infowindow';

export const addIWEventListener = () => {
  return (dispatch) => {
    const map = document.getElementById('mapsToRender');
    const iwListener = (e) => {
      const [iwButton, processed_address_street, processed_address_number] =
        e.srcElement.id.split(',');
      if (iwButton === 'IWButton') {
        const payload = {
          processed_address_street,
          processed_address_number,
        };
        dispatch(generateBuildingDetails(payload));
        map.removeEventListener('click', iwListener);
      }
    };
    map.addEventListener('click', iwListener);
  };
};

export const createOpenInfoWindowT = (data, marker, coordinates) => {
  const google = window.google;
  const infowindow = new google.maps.InfoWindow({
    content: infoWindowRealtyTransactions(data, 1),
    maxWidth: '800px',
    zIndex: 5,
  });
  infowindow.open(Map.map, marker);
  return infowindow;
};

export const generateMarkersOnMap = (geometry) => {
  return (dispatch) => {
    const google = window.google;
    const markers = geometry.map((el, index) => {
      const coords = new google.maps.LatLng(
        el.location_coordinates[1],
        el.location_coordinates[0]
      );
      const marker = new google.maps.Marker({
        position: coords,
        map: Map.map,
        icon: Icon,
      });
      marker.addListener('click', function () {
        dispatch(generateInfoWindow(el, marker));
      });
      return marker;
    });
    const clusterOptions = {
      styles: [
        {
          url: ClusterIcon,
          height: 24,
          width: 24,
          textColor: '#FFF',
          fontWeight: 400,
          textSize: 14,
          anchorText: [5, 0],
        },
      ],
    };

    const map = Map.map;
    const markerCluster = new MarkerClusterer(map, markers, clusterOptions);
    dispatch(updateMarkers(markers));
    dispatch(updateClusters(markerCluster));
  };
};
